<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="用户名称/编号/联系方式" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.searchType" placeholder="是否关联小程序" clearable>
            <template #prefix>小程序</template>
            <el-option :value="1" label="已关联"/>
            <el-option label="未关联" :value="2"/>
          </el-select>
          <el-select v-model="searchInfo.status" placeholder="是否关联报价工具" clearable>
            <template #prefix>报价工具</template>
            <el-option :value="1" label="已关联"/>
            <el-option label="未关联" :value="2"/>
          </el-select>
        </template>
        <template #option>
          <page-button hasPerm="sys:user:query" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false" :show-border="false">
        <separator-page right-back-ground="transparent">
          <template #category>
            <tree-dictionary :filter="true" v-model:dictionary-list="treeList" :disabled="true"
                             label-name="fullName"
                             @clickCategory="clickCategory" :query-function="queryCategory" dialog-label="部门管理">
            </tree-dictionary>
          </template>
          <list-page>
            <table-list>
              <yq-table v-loading="loadingData" :data="dataList" height="100%" stripe border page-name="erpCustomer" element-loading-text="正在加载数据" element-loading-spinner="el-icon-loading">
                <yq-table-column label="编号" prop="userCode" width="180rem" :show-overflow-tooltip="true"/>
                <yq-table-column label="ERP客户名称" prop="fullName" :show-overflow-tooltip="true" min-width="100rem" />
                <yq-table-column label="微信头像" prop="avatar" width="100rem">
                  <template v-slot="{row}">
                    <image-show v-if="row.avatar" :model-value="row.avatar" width="0.8rem" height="0.8rem"/>
                  </template>
                </yq-table-column>
                <yq-table-column label="微信名称" prop="customerName" :show-overflow-tooltip="true" min-width="100rem">
                  <template v-slot="{row}">
                    <span v-if="row.wxUnionId">{{ row.customerName }}</span>
                    <el-tag v-else type="info">未关联</el-tag>
                  </template>
                </yq-table-column>
                <yq-table-column label="小程序手机号" prop="customerPhone" />
                <yq-table-column label="AI报价客户名" prop="xbotId" :show-overflow-tooltip="true" >
                  <template v-slot="{row}">
                    <span v-if="row.customerXbotName">{{ row.customerXbotName }}</span>
                    <el-tag v-else type="info">未关联</el-tag>
                    <table-button @click="toAddRelationXbot(row)">{{!row.customerXbotName?"关联客户":"重新关联"}}</table-button>
                  </template>
                </yq-table-column>
              </yq-table>
            </table-list>
            <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                       :total-count="searchInfo.totalCount" @onLoad="queryList"/>
          </list-page>
        </separator-page>
      </list-table>
    </list-page>
    <el-dialog v-model="showDialog" title="选择报价工具客户信息" dialog-width="2">
      <list-page class="dialog-page">
        <search-condition @search="resetSearchDialog" :show-search="true" :show-shadow="false">
          <template #default>
            <el-input v-model="dialogSearchInfo.searchKey" placeholder="客户名称" clearable @keydown.enter="resetSearchDialog">
              <template #prefix>关键字</template>
            </el-input>
          </template>
          <template #option>
            <page-button type="read" el-type="primary" @click="resetSearchDialog">查询</page-button>
          </template>
        </search-condition>
        <list-table>
          <yq-table :data="dialogDataList" height="100%" stripe border >
            <yq-table-column label="头像" prop="avatar" width="60rem">
              <template v-slot="{row}">
                <image-show v-model="row.avatar" height=".8rem" width=".8rem"/>
              </template>
            </yq-table-column>
            <yq-table-column  label="客户名称" prop="customerName" min-width="180rem" />
            <yq-table-column label="操作" prop="potion" width="120rem" align="center">
              <template v-slot="{row}">
                <table-button @click="selectXbotCustomer(row)">选择客户</table-button>
              </template>
            </yq-table-column>
          </yq-table>
        </list-table>
        <form-page v-model:page-number="dialogSearchInfo.pageNumber" v-model:page-size="dialogSearchInfo.pageSize" :total-count="dialogSearchInfo.totalCount" @onLoad="queryListDialog" :default-load="false">
          <page-button type="write" @click="showDialog = false">取消</page-button>
        </form-page>
      </list-page>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import TableList from "@/components/h5/layout/ListTable.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import erpCustomerRelationApi from "@/api/dz-ai/erpCustomerRelationApi";
import ImageShow from "@/components/h5/image/ImageShow.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EL",
  components: {
    TableButton,
    PageButton,
    TreeDictionary,
    TableList,
    SeparatorPage,
    YqTableColumn,
    SearchCondition,
    FormPage,
    ListTable,
    ListPage,
    ImageShow
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      treeList: [],
      queryCategory: null,
      showDialog: false,
      dialogSearchInfo: {},
      dialogDataList: [],
      loadingData: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    // 注册企业微信通讯录组件
    this.queryCategory = erpCustomerRelationApi.queryCategory;
    this.resetSearch();
  },
  mounted() {

  },
  methods: {
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    queryList() {
      this.loadingData = true;
      erpCustomerRelationApi.queryErpCustomerList(this.searchInfo).then(res => {
        this.loadingData = false;
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    clickCategory(data) {
      this.searchInfo.parentId = data.typeId || "";
      this.queryList();
    },
    // dialog发起查询
    resetSearchDialog() {
      this.dialogSearchInfo.pageNumber = 1;
      this.queryListDialog();
    },
    queryListDialog() {
      erpCustomerRelationApi.queryXbotCustomerList(this.dialogSearchInfo).then(res => {
        this.dialogDataList = res.records;
        this.dialogSearchInfo.totalCount = res.totalCount;
      })
    },
    // 选中某个客户
    selectXbotCustomer(data) {
      erpCustomerRelationApi.setXbotId({id: this.currentData.id, xbotId: data.xbotId}).then(() => {
        this.showDialog = false;
        this.queryList();
      })
    },
    // 打开关联dialog去关联客户信息
    toAddRelationXbot(data) {
      this.currentData = data;
      this.showDialog = true;
      this.resetSearchDialog();
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-page{
  height: 60vh;
}
</style>